import React from "react";
import { House } from "react-bootstrap-icons";

export default function ItemHeader(props){
   

    return <div className="ith loading">
        <div className="itcd"><div className="a01 animated"> </div> </div>
        <h2 className="ittit"><div className="a02 animated"> </div> </h2>
        <div className="itbrd">
            <ul>    
                <li><House /></li>
                <li><div className="a03 animated"> </div> </li>
                <li><div className="a04 animated"> </div> </li>
                <li><div className="a05 animated"> </div> </li>
                <li className="act"><div className="a06 animated"> </div> </li>
            </ul>

        </div>
    </div>
}